import Mutations from '../../odata/mutations';

export default { ...new Mutations('client'), ...new Mutations('clients'), ...new Mutations('search') };
